/**
 * Маскирует телефон для логов и UI, сохраняя первые 4 и последние 2 символа.
 *
 * Зеркалит маску бэкенда: `+79991234567` → `+7999*****67`. Для коротких строк
 * (≤ 6 символов) возвращает звёздочки той же длины, чтобы не раскрывать длину PII.
 *
 * @param phone номер в произвольном формате
 * @returns маскированная строка
 */
export function maskPhone(phone: string): string {
  if (phone.length <= 6) {
    return '*'.repeat(phone.length);
  }
  const prefix = phone.slice(0, 4);
  const suffix = phone.slice(-2);
  const middleLength = phone.length - prefix.length - suffix.length;
  return `${prefix}${'*'.repeat(middleLength)}${suffix}`;
}
